/*
TargetGroupSpotStatus is a class-based component that fetches target group spot information and passes it down to the SpotStatus component.

1. It is called in TargetGroup.js in Spot Status tab
2. It has a default date range filter from today to seven days from today.
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createSelector } from "reselect";
import * as constants from "../../../../../constants";
import { bindDispatch } from "../../../../../utils";
import WithFetchList from "../../../../hoc/withFetchList";
import SpotStatus from "../../common/SpotStatus";
import getSpotStatusDefaultDateRange from "../../utils/getSpotStatusDefaultDateRange";

class TargetGroupSpotStatus extends Component {
  componentDidMount = async () => {
    const {
      match: {
        params: { targetGroupId },
      },
      campaigns,
    } = this.props;

    const campaign = campaigns?.campaign;
    const defaultRange = getSpotStatusDefaultDateRange("targetGroup", campaign);

    this.props.fetchData(null, true, [
      { targetGroupId },
      {
        filters: [
          {
            from: defaultRange.from,
            id: "showDate",
            type: "showDate",
            displayName: defaultRange.displayName,
            to: defaultRange.to,
          },
        ],
      },
    ]);
  };

  render = () => {
    const {
      targetGroups: { isTabLoading, targetGroupSpots },
    } = this.props;
    return (
      <SpotStatus
        {...this.props}
        data={{
          spotStatus: targetGroupSpots,
          isLoading: isTabLoading,
        }}
      />
    );
  };
}

export const TargetGroupSpotStatusWithFilters = WithFetchList("getTargetGroupSpots", {
  sort: [
    {
      id: "showDate",
      desc: false,
    },
  ],
  ps: constants.DEFAULT_PAGE_SIZE,
  page: 1,
  multiColumnSort: false,
})(TargetGroupSpotStatus);

const mapStateToProps = createSelector(
  (state) => state.targetGroups,
  (state) => state.userData,
  (state) => state.campaigns,

  (targetGroups, userData, campaigns) => ({
    targetGroups,
    campaigns,
    userData: userData.user,
  })
);

export default connect(mapStateToProps, bindDispatch)(withRouter(TargetGroupSpotStatusWithFilters));
